module.exports = __webpack_public_path__ + "img/24.9b4d2eb6.png";